import { Component, OnInit } from '@angular/core';
import { SuporteService } from '../../../services/suporte.service';
import { MinhasSolicitacoes, SolicitacaoSuporteResponse } from '../../../../../pages/models/suporte.dto';

@Component({
  selector: 'app-superadmin',
  standalone: false,
  templateUrl: './superadmin.component.html',
  styleUrls: ['./superadmin.component.css']
})
export class SuperadminComponent implements OnInit {
  tickets: MinhasSolicitacoes | null = null;
  selectedStatus: { [id: string]: string } = {};
  loading = false;

  constructor(private suporteService: SuporteService) {}

  ngOnInit(): void {
    this.loadTickets();
  }

  loadTickets(page = 0, size = 50) {
    this.loading = true;
    this.suporteService.obterTicketsAbertos(page, size).subscribe({
      next: (res) => {
        this.tickets = res;
        (res.content || []).forEach((t: SolicitacaoSuporteResponse) => {
          this.selectedStatus[t.id] = t.status || 'ABERTO';
        });
        this.loading = false;
      },
      error: (err) => {
        console.error('Erro ao carregar tickets abertos', err);
        this.loading = false;
      }
    });
  }

  applyStatus(id: string) {
    const status = this.selectedStatus[id];
    if (!status) return;
    if (!confirm(`Deseja alterar o status para ${status}?`)) return;
    this.suporteService.atualizarStatus(id, status).subscribe({
      next: () => this.loadTickets(),
      error: (err) => console.error('Erro ao atualizar status', err)
    });
  }

  // convenience to format creator
  who(t: SolicitacaoSuporteResponse) {
    return (t.nomeUsuario || '') + (t.nomeEmpresa ? ' • ' + t.nomeEmpresa : '');
  }
}
